import type { BadgeColor } from "#React/ui/Badge"
import Badge from "#React/ui/Badge"

type EnvironmentLabelProps = {
  env?: string
  className?: string
}

const ENV_COLORS: Record<string, BadgeColor> = {
  test: "orange",
  testing: "orange",
  staging: "purple",
  integration: "purple",
  acceptance: "purple",
  dev: "default",
  development: "default",
  production: "blue",
  prod: "blue"
}

const EnvironmentLabel = ({ env, className }: EnvironmentLabelProps) => {
  return (
    <Badge sans color={(env && ENV_COLORS[env]) || "default"} className={className}>
      {env}
    </Badge>
  )
}

export type { EnvironmentLabelProps }
export default EnvironmentLabel
